import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-bar d-flex align-items-center" }
const _hoisted_2 = ["placeholder"]

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    placeholder: { default: "Pesquisar" }
  },
  emits: ["onSearch"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const emit = __emit;
const searchString = ref("");
const onSearch = () => emit("onSearch", searchString.value);
const setValue = (value: string) => {
  searchString.value = value;
};
__expose({ setValue });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      spellcheck: "false",
      class: "search-bar-input text-paragraph text-primary flex-grow-1",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchString).value = $event)),
      type: "text",
      placeholder: __props.placeholder,
      id: "search-bar-input",
      onKeyup: _withKeys(onSearch, ["enter"])
    }, null, 40, _hoisted_2), [
      [
        _vModelText,
        searchString.value,
        void 0,
        { trim: true }
      ]
    ]),
    _createElementVNode("button", {
      class: "btn btn-link text-primary50 p-0 search-bar-btn",
      "aria-label": "Buscar",
      onClick: onSearch
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "fa fa-search" }, null, -1)
    ]))])
  ]))
}
}

})